import React from 'react';
import { SHYFT_EMBLEM } from '@/constants/logoAssets';

const FooterSection = () => (
  <footer className="lux-footer" data-testid="footer-section">
    <div className="lux-footer__crest">
      <img
        src={SHYFT_EMBLEM}
        alt="SHYFT Coalition"
        width={64}
        height={64}
        style={{
          objectFit: 'contain',
          filter: 'drop-shadow(0 2px 10px rgba(0, 0, 0, 0.55))',
        }}
      />
      <div className="lux-footer__brand">
        SHYFT Coalition<sup className="lux-footer__tm" aria-label="trademark">™</sup>
      </div>
    </div>

    <p className="lux-footer__tagline">Shift How You Financially Think</p>

    <div className="lux-footer__divider" aria-hidden="true" />

    <p className="lux-footer__event">2nd Annual Penthouse Christmas Party</p>
    <p className="lux-footer__meta">Saturday, December 12 · 6:00 PM – Until</p>
    <p className="lux-footer__meta">
      The Penthouse @ MET Atlanta · 680 Murphy Avenue SW · Atlanta, GA 30310
    </p>

    <div className="lux-footer__divider" aria-hidden="true" />

    <a
      href="https://SHYFTEvents.com"
      className="lux-footer__site"
      data-testid="footer-site"
    >
      SHYFTEvents.com
    </a>
    <p className="lux-footer__copy" data-testid="footer-copyright">
      <span>© 2026 SHYFT Coalition<sup className="lux-footer__tm">™</sup></span>
      <span>All Rights Reserved.</span>
    </p>
  </footer>
);

export default FooterSection;
